import { Component, OnInit,HostListener } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { switchMap, catchError, map } from 'rxjs/operators';
import { interval } from 'rxjs';
import { IBrand, IBrandHF } from '../common/ibrand';
import { RedactReplyServiceService } from '../service/redact-reply-service.service';
import { AppError } from '../common/class/app-error';
// import { of, Observable } from 'rxjs';
// import { map, catchError } from 'rxjs/operators';
import { SubSink } from '../../../node_modules/subsink';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IDisappearingInkHF, IDisappearingInk, DisappearingInk } from '../class/DisappearingInk';
import { IEmailVefifyHF, IEmailVefify, EmailVefify, IBrandDetailsHF, IBrandDetails, BrandDetails, CountryCodeDetails, ICountryCodeDetails, ICountryDialCodeForSenderAddress } from '../class/redact';
import { IPostResponseHF, IPostResponse, PostResponse } from '../class/PostResponse';
import { Router, ActivatedRoute } from '@angular/router';
import { timer, Subscription } from "rxjs";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { stringify } from 'querystring';
import { DestinationDetails } from '../class/DestinationDetails';
import { ResultContent } from '../class/AutoLockApiResponse';
import { AI_AutoLock_Access_Check } from '../service/AutoLock_Access_Check/AI_AutoLock_Access_Check';
import { AutoLockRequestModel } from '../class/AutoLockRequestModel';
import { SendAccessControlNoticeRequestv2 } from '../class/SendAccessControlNoticeRequestModel';
import { Location } from '@angular/common';
import { AppConfigService } from '../app-config.service';
import { AutoLockRequestDecisionModel, AutoLockDecisionResponse, AccessDecision } from '../class/AutoLockAccess';
import { AccessDecisionService } from '../service/AccessDecisionService';
import { SessionStateService } from '../service/session-state.service';
import {AutolockSessionStateService} from '../service/Autolock-session-state.service';
import { CryptoService } from '../service/CryptoService';
import { GuidGenerator } from '../common/class/guid-generator';
import { MailContextRequest, MailContextData } from 'src/app/class/MailContextRequest ';

@Component({
  selector: 'app-disappear-ink',
  templateUrl: './disappear-ink.component.html',
  styleUrls: ['./disappear-ink.component.scss']
})
export class DisappearInkComponent implements OnInit {
  // enableEdit: boolean = true;
  mySubscription: Subscription;
  logoId: string;
  public viewsLeft: string;
  public brandDetails = new BrandDetails;
  selectedLanguage: string;
  hideElement = false;
  destShortURL: string;
  HeaderHtml: SafeHtml;
  public DI = new DisappearingInk;
  private subs = new SubSink();
  public copied = false;
  public emailVerfication = new EmailVefify;
  public countryCodeDetails = new CountryCodeDetails;
  loginForm: FormGroup;
  loginFormSMS: FormGroup;
  emailDispatchOption: number;
  isSMSOptionEnabled: boolean = false;
  isVerified = false;
  showLogo: boolean = true;
  companyLogoURL: string = "";
  countDown: Subscription;
  confidentialityStatement: string;
  counter: number;
  tick = 1000;
  subscription: Subscription;
  isAutoLock_AccessDenied: boolean;
  accessDeniedText: string;
  isDisappearInk: boolean;
  contactSenderText: string;
  DialCodeForSenderAddress: string;
  productLine: string;
  approvedByPasscode: boolean;
  diinkRefUrl: string;
  featureType: string;
  themeValue: boolean;
  textValue: boolean;
  ActiveTabsKey: any;
  detectionKey: any;
    OpenActiveTabsKey : any;
  OpendetectionKey:any;
  AutolockActiveTabsKey: any;
  AutolockDetectionKey: any;
  crypto: CryptoService;
  deviceLogId: string = GuidGenerator.standard();
  IsDeviceFingerprintSettingEnabled: boolean = false;
    loading = true;              // Hide actual page
themeLoaded = false;         // Theme API completed
showSkeleton = false;        // Show skeleton only after theme is known

brandingLoaded = false;      // Branding API completed
destinationLoaded = false;
showContentLoader = false;
  public mailContextData!: MailContextData;
  constructor(private formBuilder: FormBuilder, private user: RedactReplyServiceService, private AI_Autolock_user: AI_AutoLock_Access_Check, private http: HttpClient, private router: Router, private route: ActivatedRoute
    , private translate: TranslateService, private location: Location, private accessDecisionService: AccessDecisionService,private sanitizer: DomSanitizer,
    private config: AppConfigService,private sessionState: SessionStateService,private AutolockSessionState: AutolockSessionStateService) {
    this.diinkRefUrl = this.config.diinkRefUrl;
    this.crypto = new CryptoService();
    // this.route.params.subscribe(params => this.destShortURL = (params.shortURL));
    this.route.params.subscribe(params => {
      const shortURL: string = params.shortURL;
      this.destShortURL = shortURL;
      this.productLine = this.config.productLine;
    });


  }
  public conditionvalue: number = 0;
  //emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  //emailPattern="^(?!\\.)(?!\\')(?!\\^)(?!\\?)(?!\\])(?!\\*)(?!\\{)(?!\\})(?!\\[)(?!.*?[.]{2})|[#!_%&$^+-][a-z0-9.!#_%'&^$?!.\]*{}\[+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
  //emailPattern="^(?!.*?[.]{2})|[a-z0-9.!#_%'&^$?!.\]/*{}\[|/~=+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
  emailPattern = "^[a-zA-Z0-9.!#_%'&^$?\\-/+=]*[a-zA-Z0-9.!#_%'&^$?\\-/+=]+@[a-zA-Z\\u0080-\\uFFFF0-9_-]+\\.[a-zA-Z]{2,4}(?:\.[a-zA-Z]{2})?$";
  phoneNumberPattern = "^[0-9+\\- ]+$";
  ngOnInit() {
     this.loading = true;
  this.themeLoaded = false;
  this.showSkeleton = false;
  this.brandingLoaded = false;
  this.destinationLoaded = false;
  this.showContentLoader=false;


    this.loginForm = this.formBuilder.group({
      emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]],
    });
    this.loginFormSMS = this.formBuilder.group({
      phoneNumber: [null, [Validators.required, Validators.pattern(this.phoneNumberPattern)]],
      countryDialCode: [null, [Validators.required]]
    });

   this.featureType = 'DisappearingInk';
       const request: MailContextRequest = {
         shortUrl: this.destShortURL,
         feature: this.featureType,
         productLine: this.config.productLine,
         deviceLogId: this.deviceLogId
       };

       this.AI_Autolock_user.getMailContext(request).subscribe({
         next: (response) => {

           if (!response || !response.success || !response.resultContent) {
             return;
           }

           // Decrypt response
           const encryptedResult = response.resultContent;

           const base64Value = this.crypto.decryptQueryString(
             encryptedResult,
             this.config.preSetEncryptPwdKey,
             this.config.preSetEncryptPwdIVector
           );

           this.mailContextData = JSON.parse(
             atob(base64Value)
           ) as MailContextData;

           // Branding
           this.getBrandingDetails();

           // Reference URL
           this.destShortURL = this.mailContextData.ShortUrl || '';
          this.diinkRefUrl = this.diinkRefUrl.replace('{shortURL}', this.destShortURL);

           // Language
           const language =
             this.mailContextData.DestinationDetails.MessageLanguage || 'en-us';

           this.translate.use(language);
           localStorage.setItem('Langauge', language);

           // Device Fingerprint
           this.IsDeviceFingerprintSettingEnabled =
             this.mailContextData.DestinationDetails.DeviceFingerprintSetting || false;

           // AutoLock validation
           if (
             !this.mailContextData.PasswordVerified &&
             this.mailContextData.DestinationDetails.RequestStatus != 2
           ) {

             if (this.mailContextData.Lock) {

               const accessControlNoticeRequest: SendAccessControlNoticeRequestv2 = {
                 lockId: this.mailContextData.LockId,
                 shortUrl: this.mailContextData.ShortUrl,
                 feature: 'RMail - Disappearing Ink'
               };

               // Removal Request Enabled
               if (
                 this.mailContextData.EnableRemovalRequest !== null &&
                 this.mailContextData.EnableRemovalRequest
               ) {

                 (async () => {
                   await this.triggerDetectionAndNotifyAccess(
                     this.destShortURL,
                     this.mailContextData.LockId || '',
                     accessControlNoticeRequest,
                     this.mailContextData.IpAddress || ''
                   );
                 })();

                 if (
                   this.mailContextData.DestinationDetails != null &&
                   this.mailContextData.DestinationDetails.RequestStatus != 2
                 ) {

                   const accessDecision: AccessDecision = {
                     Id: this.mailContextData.DestinationDetails.MessageId,
                     Feature: this.featureType,
                     Key: this.destShortURL,
                     Count:
                       this.mailContextData.DestinationDetails.RequestsCount != null
                         ? this.mailContextData.DestinationDetails.RequestsCount
                         : 0,
                     Status:
                       this.mailContextData.DestinationDetails.RequestStatus != null
                         ? this.mailContextData.DestinationDetails.RequestStatus
                         : 0,
                     Lang:
                       this.mailContextData.DestinationDetails.MessageLanguage,
                     RefUrl: this.diinkRefUrl,
                     Theme: null,
                     Source: null,
                     hashedLockId: this.mailContextData.LockId,
                     EMailDispatchOption: this.mailContextData.DestinationDetails.EMailDispatchOption,
                     PhoneNumber: this.mailContextData.DestinationDetails.PhoneNumber,
                     DestinationName: this.mailContextData.DestinationDetails.DestinationName,
                     SenderAddress: this.mailContextData.DestinationDetails.SenderAddress,
                     MessageSubject: this.mailContextData.DestinationDetails.MessageSubject,
                     DestinationAddress: this.mailContextData.DestinationDetails.DestinationAddress
                   };

                   this.accessDecisionService.setAccessDecision(
                     accessDecision
                   );

                   this.router.navigate([
                     '/requestaccess/RD'
                   ]);

                   return;
                 }
               }

               // Removal Request Disabled
               else {

                 (async () => {
                   await this.triggerDetectionAndNotifyAccess(
                     this.destShortURL,
                     this.mailContextData.LockId || '',
                     accessControlNoticeRequest,
                     this.mailContextData.IpAddress || ''
                   );
                 })();

                 this.isAutoLock_AccessDenied = true;
                 this.accessDeniedText = 'Access Denied';
                 this.contactSenderText =
                   'Please contact the sender for further information.';
                 this.isDisappearInk = false;

                 this.location.go(
                   '/accessdenied/' +
                   this.destShortURL +
                   '/RD'
                 );

                 return;
               }
             }

             // Access Allowed
             else {

               console.log('Access is allowed');

               (async () => {
                 await this.triggerDetectionAndNotifyAccess(
                   this.destShortURL,
                   '',
                   null,
                   this.mailContextData.IpAddress || ''
                 );
               })();

               this.isAutoLock_AccessDenied = false;
               this.accessDeniedText = '';
               this.contactSenderText = '';
               this.isDisappearInk = false;

               this.getCountryDialCodeList();

               this.loginForm = this.formBuilder.group({
                 emailId: [
                   null,
                   [
                     Validators.required,
                     Validators.pattern(this.emailPattern)
                   ]
                 ]
               });

               this.loginFormSMS = this.formBuilder.group({
                 phoneNumber: [
                   null,
                   [
                     Validators.required,
                     Validators.pattern(this.phoneNumberPattern)
                   ]
                 ],

                 countryDialCode: [
                   null,
                   [Validators.required]
                 ]
               });
             }

             // AutoLock feature disabled
             if (!this.mailContextData.AutoLockEnabled) {

               console.log(
                 'Autolock feature is not enabled'
               );

               (async () => {
                 await this.triggerDetectionAndNotifyAccess(
                   this.destShortURL,
                   '',
                   null,
                   this.mailContextData.IpAddress || ''
                 );
               })();

               this.isAutoLock_AccessDenied = false;
               this.accessDeniedText = '';
               this.contactSenderText = '';
               this.isDisappearInk = false;

               this.getCountryDialCodeList();

               this.loginForm = this.formBuilder.group({
                 emailId: [
                   null,
                   [
                     Validators.required,
                     Validators.pattern(this.emailPattern)
                   ]
                 ]
               });

               this.loginFormSMS = this.formBuilder.group({
                 phoneNumber: [
                   null,
                   [
                     Validators.required,
                     Validators.pattern(this.phoneNumberPattern)
                   ]
                 ],

                 countryDialCode: [
                   null,
                   [Validators.required]
                 ]
               });
             }
           }

           // Passcode approved / Request already approved
           else {

             (async () => {
               await this.triggerDetectionAndNotifyAccess(
                 this.destShortURL,
                 '',
                 null,
                 this.mailContextData.IpAddress || ''
               );
             })();

             this.isAutoLock_AccessDenied = false;
             this.accessDeniedText = '';
             this.contactSenderText = '';
             this.isDisappearInk = false;

             this.getCountryDialCodeList();

             this.loginForm = this.formBuilder.group({
               emailId: [
                 null,
                 [
                   Validators.required,
                   Validators.pattern(this.emailPattern)
                 ]
               ]
             });

             this.loginFormSMS = this.formBuilder.group({
               phoneNumber: [
                 null,
                 [
                   Validators.required,
                   Validators.pattern(this.phoneNumberPattern)
                 ]
               ],

               countryDialCode: [
                 null,
                 [Validators.required]
               ]
             });
           }
         },

         error: (error) => {
           console.error(
             'Error during mail context request:',
             error
           );
         }
       });


  }


  async triggerDetectionAndNotifyAccess(
    ShortURL: string,
    LockId: string,
    request: SendAccessControlNoticeRequestv2 | null,
    ipAddress : string
  ): Promise<void> {
    //opendetection
    this.ActiveTabsKey = `di_${this.destShortURL}_${ipAddress}`;
    this.detectionKey = `DIODT_${this.destShortURL}_${ipAddress}`;
    //autolock opendetection
    this.OpenActiveTabsKey = `odi_${this.destShortURL}_${ipAddress}`;
    this.OpendetectionKey = `ODIODT_${this.destShortURL}_${ipAddress}`;
    //autolock
    this.AutolockActiveTabsKey = `Adi_${this.destShortURL}`;
    this.AutolockDetectionKey = `ADIODT_${this.destShortURL}`;
    var savedFingerprintDetails = false;
    //without autolock enabled
    if (!LockId && !request) {
      this.sessionState.setKeys(this.detectionKey, this.ActiveTabsKey);
      if (this.sessionState.isFirstVisit()) {
        this.sessionState.markVisited();
        
        if(this.IsDeviceFingerprintSettingEnabled)
        {
          savedFingerprintDetails = await this.saveFingerprintDetails();
        }
        else{
          savedFingerprintDetails = true;
        }
        if(savedFingerprintDetails){
          await this.triggerOpenDetection(ShortURL);
        }
        // return;
      } else {
        console.log('Open detection already triggered or new tab — skipping.');
      }
    }
    //autolock enabled
    if (LockId && request) {
      this.sessionState.setKeys(this.OpendetectionKey, this.OpenActiveTabsKey);

      if (this.sessionState.isFirstVisit()) {
        this.sessionState.markVisited();
        const finalShortURL = `${ShortURL}@${LockId}`;
        
        if(this.IsDeviceFingerprintSettingEnabled)
        {
          savedFingerprintDetails = await this.saveFingerprintDetails();
        }
        else{
          savedFingerprintDetails = true;
        }
        if(savedFingerprintDetails){
          await this.triggerOpenDetection(finalShortURL);
        }
        // return;
      } else {
        console.log('Open detection already triggered or new tab — skipping.');
      }
       this.AutolockSessionState.setKeys(this.AutolockActiveTabsKey, this.AutolockDetectionKey);
      if (this.AutolockSessionState.isFirstVisit()) {
        this.AutolockSessionState.markVisited();
        if(savedFingerprintDetails){
        await this.sendAccessControlNotice(request);
        }
        // return;
      } else {
        console.log('sendAccessControlNotice already triggered or new tab — skipping.');
      }
    }
  }
  async triggerOpenDetection(id: string): Promise<void> {

    try {
      const success = await this.AI_Autolock_user
        .triggerOpenDetection(id, "DisappearingInk", this.deviceLogId)
        .toPromise();

      if (success) {
        console.log('Open detection triggered successfully');
      }
    }
    catch (error) {
      console.error('Error triggering open detection:', error);
    }
  }
  async saveFingerprintDetails(): Promise<boolean> {

    try {
if(!this.IsDeviceFingerprintSettingEnabled)
        {
          this.deviceLogId = "";
        }
      const encryptedFP = await (window as any) .collect();
      const success = await this.AI_Autolock_user.saveFingerprintDetails(this.deviceLogId, encryptedFP)
          .toPromise();

      if (success) {
        return true;
      }
      return false;
    }
    catch (error) {
      return true;
    }
  }
  async sendAccessControlNotice(request: SendAccessControlNoticeRequestv2): Promise<void> {
    try {
      const response = await this.AI_Autolock_user
        .sendAccessControlNoticeV2(request)
        .toPromise();

      if (response && response.isSuccess) {
        console.log('AccessControlNotice sent Successfully');
      } else {
        console.log('AccessControlNotice Failed');
      }
    } catch (error) {
      console.error('Error sending access control notice:', error);
    }
  }


  async detectClientInfo(): Promise<{ ipAddress: string, userAgent: string, referer: string, language: string }> {
    const serverVariables = await this.AI_Autolock_user.getServerVariables().toPromise();

    if (serverVariables) {
      const { IPAddress, UserAgent, Referer, BrowserLanguage } = serverVariables;
      return {
        ipAddress: IPAddress || null,
        userAgent: UserAgent || null,
        referer: Referer || null,
        language: BrowserLanguage || null
      };
    } else {
      return {
        ipAddress: null,
        userAgent: null,
        referer: null,
        language: null
      };
    }
  }

  getDITextView() {
    this.subs.sink = this.user.postDITextView(this.destShortURL, "")
      // this.subs.sink = this.user.getDITextView(this.destShortURL)
      .subscribe(resp => {

        if (!(resp instanceof AppError)) {

          const response = resp as IDisappearingInkHF;
          const result = response.ResultContent;
          this.DI = result;
          if (response.ResultContent.TTDT) {
          this.router.navigate(
              ['transactionTerminated'],
              { skipLocationChange: true }
          );
          return;
        }

         // this.DI.TimeAllowed=2;

        //  this.DI.DisplayViewsLeft="1";
          //     localStorage.setItem('redact', null);
          localStorage.setItem('disapperInk', JSON.stringify(this.DI));

          if (this.DI.LogoSrc == null || this.DI.LogoSrc == "") {
            this.showLogo = false;
          }
          else {
            this.showLogo = true;
            this.companyLogoURL = this.DI.LogoSrc;
          }

          this.confidentialityStatement = this.DI.ConfidentialityStatement;

          const source = interval(this.DI.TimeAllowed * 1000);
          this.subscription = source.subscribe(val => this.redirectToTimeRemaining());

          let count: number = 1;
          this.textValue=true;
          if (this.DI.DisappearingInkText != null) {
            // this.copyText=this.copyText.concat( this.DI.DisappearingInkCustomText );
            // this.copyText=this.copyText.concat(" :");
            //    this.copyText=this.copyText.concat('\n');
            //   this.copyText=this.copyText.concat(this.DI.DisappearingInkText);
            this.copyText = this.copyText.concat(this.DI.DisappearingInkText.toString().replace("<br/>", "\n"));
            this.copyText = this.copyText.concat('\n');
          }
          this.translate.use(this.DI.Language);
          this.selectedLanguage = this.DI.Language;
          localStorage.setItem('Langauge', this.DI.Language);
          this.logoId = this.DI.LogId;
          if ((this.DI.ViewsLeft == "0") || (this.DI.IsDisappearingInkExpired == true)) {
            this.router.navigate(['DIviewRemaining'], { skipLocationChange: true });
          }
           this.showContentLoader = false;
        }
       },
      error => {
          this.showContentLoader = false;
      });


  }
  getCountryDialCodeList() {
    this.subs.sink = this.user.getCountryDialCodeList()
      .subscribe(resp => {
        if (!(resp instanceof AppError)) {
          const response = resp as ICountryCodeDetails;
          // const result = response.ResultContent;
          this.countryCodeDetails = response;
        }
      })

  }

  redirectToTimeRemaining() {
    this.router.navigate(['DItimeRemaining'], { skipLocationChange: true });
  }
  public copyText: string = "";

  copyMessage() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.copyText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.copied = true;
    setTimeout(() => {                           //<<<---using ()=> syntax
      this.copied = false;
    }, 3000);
  }
  EmailVerification(emailID: string, phoneNumber: string, countryDialCode: string) {
      this.showContentLoader = true;
    this.subs.sink = this.user.postUserVerification(this.destShortURL, emailID, phoneNumber, countryDialCode, "DI")
      .subscribe(resp => {
        if (!(resp instanceof AppError)) {
          const response = resp as IEmailVefifyHF;
          const result = response.ResultContent;
          this.emailVerfication = result;
          if (this.emailVerfication.Verified.toString() == "true") {
            this.getDITextView();
            this.countDown = timer(0, this.tick)
              .subscribe(() => --this.DI.TimeAllowed);

          if (this.DI.TimeAllowed > 0) {
              this.subs.sink = this.user.apiDITextViewDuration(this.logoId)
                  .subscribe();
          }

          this.isVerified = true;
          }
          else {
             this.showContentLoader = false;
            this.validEmail = false;
            this.validNumber = false;
          }

          //     localStorage.setItem('disapperInk',null);
        }
      });

  }
  validEmail: boolean = true;
  validNumber: boolean = true;
  verifyEmail(form: FormGroup) {
    if (this.loginForm.invalid) {

      if (this.loginForm.controls.emailId.errors)
        this.validEmail = false;


      return;
    }
    this.validEmail = true;
    let email = this.loginForm.controls.emailId.value;
    let phoneNumber = null;
    let countryDialCode = null;
    this.EmailVerification(email.toString(), phoneNumber, countryDialCode);

  }
  verifyNumber(form: FormGroup) {
    if (this.loginFormSMS.invalid) {

      if (this.loginFormSMS.controls.phoneNumber.errors) {
        this.validNumber = false;
      }
      return;
    }
    this.validNumber = true;
    let email = null;
    let phoneNumber = this.loginFormSMS.controls.phoneNumber.value;
    let countryDialCode = this.loginFormSMS.controls.countryDialCode.value;
    this.EmailVerification(email, phoneNumber.toString(), countryDialCode.toString());
  }
 getBrandingDetails() {

  this.subs.sink = this.user.postUserInformation(this.destShortURL, "DI")
    .subscribe(
      resp => {

        if (!(resp instanceof AppError)) {

          const response = resp as IBrandDetailsHF;
          this.brandDetails = response.ResultContent;

          // Theme
          this.themeValue = this.brandDetails.Theme != 2;

          localStorage.setItem('themeValue', JSON.stringify(this.themeValue));

          // Email/SMS option
          this.emailDispatchOption = this.brandDetails.EMailDispatchOption;
          this.isSMSOptionEnabled = this.emailDispatchOption == 2;

          // Get sender dial code if SMS is enabled
          if (this.isSMSOptionEnabled) {

            this.subs.sink = this.user
              .postCountryDialCodeForSenderAddress(this.destShortURL)
              .subscribe(resp => {

                if (!(resp instanceof AppError)) {

                  const response = resp as ICountryDialCodeForSenderAddress;
                  this.DialCodeForSenderAddress = response.DialCode;

                }

              });

          }

          // Logo
          if (this.brandDetails.LogoSrc == null || this.brandDetails.LogoSrc == "") {

            this.showLogo = false;

          }
          else {

            this.showLogo = true;
            this.companyLogoURL = this.brandDetails.LogoSrc;

          }

        }

        // Theme is known
        this.themeLoaded = true;

        // Show skeleton with correct theme
        this.showSkeleton = true;

        // Branding completed
        this.brandingLoaded = true;
        this.destinationLoaded=true;

        // Continue loading page
        this.checkPageReady();

      },
      error => {

        console.error(error);

        this.themeLoaded = true;
        this.showSkeleton = true;
        this.brandingLoaded = true;
        this.destinationLoaded=true;

        this.checkPageReady();

      });

}
  sanitizeHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  handleKeyUp(event: any) {

    if (event.keyCode === 13) {

      this.verifyEmail(event);

    }

  }

  private checkPageReady(): void {
  if (this.brandingLoaded && this.destinationLoaded) {
     this.showSkeleton = false;
   setTimeout(() => {
      this.loading = false;
    }, 5000); // Test only

  }
}

}